import peiAnalysisServices from '@/utils/constants/pei/peiAnalysisService.js';

export default {
  resource: (state) => (id) => {
    return state.resources[id];
  },
  defaultGrade: (state) => {
    return state.catalogueOptions.grades.find(
      (grade) => grade.id === state.base.peiGgradeId
    );
  },
  canShowSummaryResultParam: (state) => {
    return JSON.parse(
      state.sysParameters.ShowSummaryResultInPei?.staticValue?.toLowerCase() ??
        false
    );
  },
  canShowCompensatoryServicesInPeiParam: (state) => {
    return JSON.parse(
      state.sysParameters.ShowCompensatoryServicesInPei?.staticValue?.toLowerCase() ??
        false
    );
  },
  canShowSummaryResultParam: (state) => {
    return JSON.parse(
      state.sysParameters.ShowSummaryResultInPei?.staticValue?.toLowerCase() ??
        false
    );
  },
  isDiscipline: (state) => {
    const DISCIPLINE_TYPE_CODES = [
      peiAnalysisServices.EducacionEspecial,
      peiAnalysisServices.Educativo,
      peiAnalysisServices.Otros,
      peiAnalysisServices.EducacionFisicaAdaptada,
      peiAnalysisServices.EducacionFisicaAdaptadaCombinada,
      peiAnalysisServices.ServicioCiegos,
      peiAnalysisServices.ServicioSordos,
      peiAnalysisServices.LenguajeSenas,
    ];

    return DISCIPLINE_TYPE_CODES.includes(state?.selectedArea?.value);
  },
  showNecessitiesCatalogue: (state, getters) => {
    const isParameterActive = JSON.parse(
      state.sysParameters?.PEIStrengthsAndNeedsCatalog?.staticValue?.toLowerCase() ??
        false
    );

    // areas from program service
    const areas = [
      61, // conductual
    ];

    return (
      isParameterActive &&
      (getters.isDiscipline || areas.includes(state?.selectedArea?.id))
    );
  },
  hasStrengthEdition: (_, getters) => {
    return (
      !getters.showNecessitiesCatalogue ||
      !getters.strengthsOptions.length ||
      getters.strengthsOptions.some((x) => x.keyId || x.id < 0)
    );
  },
  hasNecessityEdition: (_, getters) => {
    return (
      !getters.showNecessitiesCatalogue ||
      !getters.necessityOptions.length ||
      getters.necessityOptions.some((x) => x.id < 0)
    );
  },
  hasSkillEdition: (_, getters) => {
    return (
      !getters.showNecessitiesCatalogue ||
      !getters.skillOptions.length ||
      getters.skillOptions.some((x) => x.keyId || x.id < 0)
    );
  },
  adequacyOptions: (state) => {
    return state.catalogueOptions.adequacy;
  },
  termOptions: (state) => {
    return state.catalogueOptions.terms;
  },
  suitabilityOptions: (state) => {
    return state.catalogueOptions.suitabilities;
  },
  instrumentOptions: (state) => {
    return state.catalogueOptions.instruments;
  },
  necessityOptions: (state) => {
    return state.catalogueOptions.necessities;
  },
  skillOptions: (state) => {
    return state.catalogueOptions.skills;
  },
  gradeOptions: (state) => {
    return state.catalogueOptions.grades;
  },
  proceduresOptions: (state) => {
    return state.catalogueOptions.availableProcedures;
  },
  strengthsOptions: (state) => {
    return state.catalogueOptions.availableStrengths;
  },
  subAreasOptions: (state) => {
    return state.catalogueOptions.subAreas;
  },
  selectedSubAreas: (state) => {
    return state.selectedSubAreas;
  },
  isIncompleteNecessitySelection: (state) => {
    const skillNames = state.createdGoals
      .map((x) =>
        x.strenghtsAndNecessities.map((y) =>
          y.name.trim().replace(/[\u0000-\u001F\u007F-\u009F]/g, '')
        )
      )
      .flat();

    const isIncomplete = state.selectedNecessities.some(
      (x) =>
        !skillNames.includes(
          x.name.trim().replace(/[\u0000-\u001F\u007F-\u009F]/g, '')
        )
    );

    return isIncomplete;
  },
};
